var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{attrs:{"fluid":""}},[_c('section-contacto-principal',{attrs:{"content":_vm.section_contacto}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }